import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authdApiRequest } from '../utils/api';
import { toast } from 'react-toastify';
import { jwtDecode } from "jwt-decode";
import Layout from '../components/Layout';

function Settings() {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    try {
      const response = await authdApiRequest(`${process.env.REACT_APP_API_HOST}/users/current`);
      const data = await response.json();
      setUserData(data);
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };

  const handleSwitchOrg = async (orgSlug) => {
    try {
      const response = await authdApiRequest(`${process.env.REACT_APP_API_HOST}/auth/switchorg`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ slug: orgSlug }),
      });
      const data = await response.json();
      if (data.token) {
        localStorage.setItem('jwt', data.token);

        // Decode the JWT to extract user roles
        const decodedToken = jwtDecode(data.token);
        const isAdmin = decodedToken.isAdmin || false;
        const isGod = decodedToken.isGod || false;
        const isOwner = decodedToken.isOwner || false;

        // Store roles in local storage
        if (isAdmin) {
          localStorage.setItem('isAdmin', isAdmin);
        }
        if (isGod) {
          localStorage.setItem('isGod', isGod);
        }
        if (isOwner) {
          localStorage.setItem('isOwner', isOwner);
        }

        localStorage.setItem('user', JSON.stringify(data.user));

        toast.success('Organization switched successfully');
        fetchUserData();
      } else {
        const errorMessage = data.error || "An error has occurred, please try again.";
        toast.error(errorMessage);
      }
      // Optionally, refresh the page or update the state to reflect the change
    } catch (error) {
      console.error('Error switching organization:', error);
      toast.error('Error switching organization');
    }
  };

  const handleSetDefaultOrg = async (orgId) => {
    try {
      const response = await authdApiRequest(`${process.env.REACT_APP_API_HOST}/users/defaultorg`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ orgId }),
      });

      if (response.ok) {
        toast.success('Default organization switched successfully');
        fetchUserData();
      } else {
        console.error('Error setting default organization:', await response.text());
        toast.error('Error setting default organization');
      }
    } catch (error) {
      console.error('Error setting default organization:', error);
      toast.error('Error setting default organization');
    }
  };

  return (
    <Layout>
      <h1 className="text-2xl font-bold mb-8">Settings</h1>
      {userData && (
        <div className="my-8">
          {userData.isGod && <div className="mb-4"><span className="px-2 py-1 bg-pink-500 text-white rounded-full">God Mode</span></div>}
          <div className="mb-6">
            <p className="text-lg">
              <span className="font-semibold">Name:</span> {userData.name}
            </p>
            <p className="text-lg">
              <span className="font-semibold">Email:</span> {userData.email}
            </p>
          </div>

          {userData.organizations && userData.organizations.length > 0 && (
            <>
              <h3 className="text-xl font-semibold mb-4">Organizations</h3>
              <ul className="space-y-4">
                {userData.organizations.map((org) => (
                  <li key={org.id} className="p-4 bg-neutral-900 rounded-lg shadow-sm">
                    <div className="flex items-center justify-between">
                      <div>
                        <div className="mb-2">
                          {org.currentOrg && <span className="mr-2 px-2 py-1 bg-green-500 text-white rounded-full text-xs">Current</span>}
                          {org.defaultOrg && <span className="mr-2 px-2 py-1 bg-yellow-500 text-white rounded-full text-xs">Default</span>}
                          {org.isAdmin && <span className="mr-2 px-2 py-1 bg-red-500 text-white rounded-full text-xs">Admin</span>}
                          {org.isOwner && <span className="mr-2 px-2 py-1 bg-purple-500 text-white rounded-full text-xs">Owner</span>}
                        </div>
                        <div>
                          <span className="text-lg font-semibold">{org.name}</span>
                        </div>
                      </div>
                    </div>
                    <div className="mt-2">
                      <h4 className="text-md font-semibold">Teams</h4>
                      <ul className="list-disc list-inside">
                        {org.teams.map((team) => (
                          <li key={team.id} className="flex items-center">
                            {team.name} <span className={`ml-1 px-2 py-0.5 text-xs rounded-full ${
                              team.role.toLowerCase() === 'lead' ? 'bg-green-500' : 'bg-blue-500'
                            } text-white`}>
                              {team.role.charAt(0).toUpperCase() + team.role.slice(1)}
                            </span>
                          </li>
                        ))}
                        {org.teams.length === 0 && <li className="flex items-center text-neutral-500">No Teams</li>}
                      </ul>
                    </div>
                    {userData.organizations.length > 1 && !org.currentOrg && (
                        <button
                          onClick={() => handleSwitchOrg(org.slug)}
                          className="mr-4 mt-4 px-3 py-1 bg-blue-500 text-white text-sm rounded-md hover:bg-blue-600"
                        >
                          Switch to {org.name}
                        </button>
                      )}
                      {!org.defaultOrg && (
                        <button
                          onClick={() => handleSetDefaultOrg(org.id)}
                          className="mt-4 px-3 py-1 bg-yellow-500 text-white text-sm rounded-md hover:bg-yellow-600"
                        >
                          Set as Default
                        </button>
                      )}
                  </li>
                ))}
              </ul>
            </>
          )}
        </div>
      )}
      <div className="flex flex-col space-y-4">
        <button
          onClick={() => navigate('/changepassword')}
          className="p-2 bg-sky-500 text-white rounded-md"
        >
          Change Password
        </button>


      </div>
    </Layout>
  );
}

export default Settings;

